import React from 'react';
import ReactDOM from 'react-dom/client';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import App from './App';

const nonce = document
  .querySelector('meta[property="csp-nonce"]')
  ?.getAttribute('content');

const emotionCache = createCache({
  key: 'mui',
  nonce: nonce || undefined,
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <CacheProvider value={emotionCache}>
    <App />
  </CacheProvider>
)